import React from 'react';
export function HeroSection() {
  return <section className="relative flex items-center justify-center py-6 md:py-10 px-5 overflow-hidden bg-dark-bg" data-id="element-70">
      {/* Background Gradients */}
      <div className="absolute inset-0 z-0 pointer-events-none" style={{
      background: `
            radial-gradient(ellipse at top left, rgba(107,0,182,0.6) 0%, transparent 60%),
            radial-gradient(ellipse at bottom right, rgba(194,0,111,0.5) 0%, transparent 60%),
            radial-gradient(ellipse at center, rgba(0,102,255,0.2) 0%, transparent 70%)
          `
    }} data-id="element-71" />

      {/* Rotating Swirl */}
      <div className="absolute top-1/2 left-1/2 w-[800px] h-[800px] rounded-full -translate-x-1/2 -translate-y-1/2 animate-swirl-rotate z-0 pointer-events-none" style={{
      background: `conic-gradient(
            from 0deg,
            rgba(255,45,155,0.08),
            rgba(107,0,182,0.08),
            rgba(0,102,255,0.08),
            rgba(255,215,0,0.06),
            rgba(255,45,155,0.08)
          )`
    }} data-id="element-72" />

      <div className="max-w-[800px] w-full flex flex-col items-center text-center relative z-10" data-id="element-73">
        <span className="inline-block bg-gradient-to-br from-magenta to-purple-mid text-white font-heading font-bold text-[0.75rem] tracking-[2px] uppercase py-1 px-[14px] rounded-full mb-1" data-id="element-74">
          El Camino a la Recuperación
        </span>

        <h1 className="font-heading font-black mb-1 text-[28px] leading-[1.15]" data-id="element-75">
          De la culpa al control consciente
        </h1>

        <p className="text-[clamp(0.9rem,1.8vw,1.1rem)] text-white/85 leading-[1.45] mb-2 max-w-[600px]" data-id="element-76">
          Cómo interrumpir el impulso de recaer en los 10 minutos más peligrosos
          de tu día — Sin usar fuerza de voluntad."
        </p>

        {/* Book Image */}
        <div className="flex justify-center items-center relative my-2 w-full" data-id="element-77">
          <div className="absolute w-[110%] h-[110%] rounded-full bg-[radial-gradient(ellipse,rgba(194,0,111,0.2)_0%,transparent_70%)] animate-glow-pulse pointer-events-none" data-id="element-78" />
          <img src="https://cdn.magicpatterns.com/uploads/pJZQQ1y91fqaN7VirMLzzV/oDiXxM0087776.webp" alt="Placer, Culpa y Vacío — 4 volúmenes — Dr. Eduardo Ortiz" className="w-full max-w-[340px] rounded-2xl drop-shadow-[0_20px_60px_rgba(194,0,111,0.5)] drop-shadow-[0_0_40px_rgba(107,0,182,0.4)] animate-float relative z-10" data-id="element-79" />
        </div>

        <div className="bg-gradient-to-br from-[rgba(194,0,111,0.15)] to-[rgba(107,0,182,0.15)] border border-[rgba(194,0,111,0.4)] rounded-xl p-3 mb-2 w-full max-w-[600px]" data-id="element-80">
          <p className="font-heading font-bold text-[0.95rem] text-gold leading-[1.4]" data-id="element-81">
            El sistema de 4 volúmenes que reprograma tu respuesta a la dopamina
            en 21 días. Pago único, 100% privado."
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center flex-wrap gap-2" data-id="element-82">
          <a href="#oferta" className="inline-block bg-gradient-to-br from-magenta to-magenta-bright text-white font-heading font-extrabold text-[1rem] py-[14px] px-[36px] rounded-full uppercase tracking-[1px] shadow-[0_8px_30px_rgba(194,0,111,0.5),0_0_60px_rgba(194,0,111,0.2)] transition-all duration-300 hover:-translate-y-[3px] hover:shadow-[0_12px_40px_rgba(194,0,111,0.7),0_0_80px_rgba(194,0,111,0.3)] text-center w-full sm:w-auto" data-id="element-83">
            → SI, Quiero CAMBIAR MI VIDA AHORA
          </a>
          <a href="#como-funciona" className="inline-block bg-transparent text-white font-heading font-bold text-[0.85rem] py-[10px] px-[28px] rounded-full border-2 border-white/30 transition-all duration-300 hover:border-magenta-bright hover:text-magenta-bright text-center w-full sm:w-auto" data-id="element-84">
            ¿Cómo funciona?
          </a>
        </div>
      </div>
    </section>;
}